import VerificationInspectionDashboards from './Dashboard';

export default VerificationInspectionDashboards;
